import React from "react";

import Module_1 from "./AboutUsModules/Module_1";
import Module_2 from "./AboutUsModules/Module_2";
import Module_3 from "./AboutUsModules/Module_3";
import Module_4 from "./AboutUsModules/Module_4";
import Module_5 from "./AboutUsModules/Module_5";
import Module_6 from "./AboutUsModules/Module_6";
import Module_7 from "./AboutUsModules/Module_7";
export default function AboutUs() {
    return (
        <main className="pt-3">
            <div className="m-auto about-us mw-900">
                <Module_1 />
                <Module_2 />
                <Module_3 />
                <Module_4 />
                <Module_5 />
                <Module_6 />
            </div>
            <Module_7 />
        </main>
    );
}
